import { FilterActionsEnum } from '@unifyapps/defs/types/blocks';
import useEventCallback from '@unifyapps/hooks/useEventCallback';
import type { QuickFiltersProps } from './types';
import { getUpdatedQuickFilter } from './utils';

export function useQuickFilters(props: QuickFiltersProps) {
  const { quickFilterActions, setFilters, filterState } = props;
  const onClickQuickFilter = useEventCallback((id: string, type: FilterActionsEnum) => {
    const isAlreadySelected =
      filterState?.dateQuickFilter?.id === id || filterState?.dataQuickFilter?.id === id;

    if (isAlreadySelected) {
      if (type === FilterActionsEnum.DateFilter) {
        setFilters({
          dateQuickFilter: null,
        });
      } else {
        setFilters({
          dataQuickFilter: null,
        });
      }
      return;
    }

    if (type === FilterActionsEnum.DateFilter) {
      const quickFilter = quickFilterActions?.find((filter) => filter.id === id);
      setFilters({
        dateQuickFilter: quickFilter,
      });
    } else {
      const quickFilter = quickFilterActions?.find((filter) => filter.id === id);
      setFilters({
        dataQuickFilter: getUpdatedQuickFilter(quickFilter),
      });
    }
  });

  return { onClickQuickFilter };
}
